<tec-profile [name]="fullName">
	@if (menuOptions.length > 0) {
		<tec-menu [options]="menuOptions" (valueChange)="onMenu($event)">
			<tec-button-icon [icon]="'icon-more'" [type]="'default'" [disabled]="menuDisabled"></tec-button-icon>
		</tec-menu>
	}

	<tec-list-detail>
		<div class="info-group info-group--column">
			<app-uuid-flexible-display
				[uuid]="detail?.process_uuid"
				[label]="'PROCESSES.DETAIL.ID_PROCESS' | translate"
			/>
			<tec-info-group>
				<b>{{ 'PROCESSES.DETAIL.COMPANY' | translate }}</b>
				<tec-link [href]="'/settings/companies'" [label]="detail?.general?.company" />
			</tec-info-group>
			<tec-info-group>
				<b>{{ 'PROCESSES.DETAIL.DATE_LAST_UPDATE' | translate }}</b>
				<span>{{ detail?.general?.end_operation | safeDate: 'dd/MM/yyyy - HH:mm' }}</span>
			</tec-info-group>
		</div>
	</tec-list-detail>

	<tec-tag
		[label]="'MASTER.STATUS.' + detail.status_process | translate"
		[status]="masterService.getTagStatus(detail.status_process)"
	></tec-tag>

	@if (detail?.general?.validation) {
		<tec-tag
			[label]="
				`PROCESSES.DETAIL.${detail?.general?.validation === 'auto' ? 'AUTOMATIC' : 'MANUAL'}` | translate
			"
		></tec-tag>
	}

	<app-identity-info-tile
		[hasData]="!!detail?.identity"
		[fullName]="fullName"
		[identifier]="detail?.identity?.identifier"
		[documentType]="detail?.identity?.document_type"
		[expirationDate]="detail?.identity?.expiration_date"
		[birthDate]="detail?.identity?.birthdate"
		[ageYears]="processHelper.ocrDocumentAgeKnown ? processHelper.yearsOld : null"
		[gender]="detail?.identity?.gender"
		[nationality]="detail?.identity?.nationality || detail?.data?.OCR?.nationality"
		[showEdit]="showEditIdentity"
		[curlPath]="identityCurlPath"
		curlTitleKey="PROCESSES.CURL_MODAL.TITLE_IDENTITY"
		(editIdentity)="onEditIdentity()"
	>
		@if (detail?.identity?.identifier) {
			<ng-container identityIdentifierActions>
				<ng-container
					[ngTemplateOutlet]="BLOCK_UNLOCK_ICONS"
					[ngTemplateOutletContext]="{ defaultBlocks: ['ocr'], defaultUnblocks: ['ocr'] }"
				/>
			</ng-container>
		}
		@if (detail?.identity?.uuid && rolePermissions.canViewPersons()) {
			<tec-link identityFooter [href]="'/identities/detail/' + detail.identity.uuid">
				{{ 'PROCESSES.MENU.VIEW_IDENTITY' | translate }}
			</tec-link>
		}
	</app-identity-info-tile>
</tec-profile>

<ng-template #BLOCK_UNLOCK_ICONS let-defaultBlocks="defaultBlocks" let-defaultUnblocks="defaultUnblocks">
	@for (menu of processHelper.detailMenuOpt(detail, false); track $index) {
		@if (menu.id === menuItemAction.BLOCK) {
			<tec-button-icon
				icon="icon-lock"
				size="sm"
				[tooltip]="'BUTTON.BLOCK' | translate"
				(click)="onIdentityMenu(menu, defaultBlocks || [])"
			/>
		}
		@if (menu.id === menuItemAction.UNLOCK) {
			<tec-button-icon
				icon="icon-unlock"
				size="sm"
				[tooltip]="'BUTTON.UNBLOCK' | translate"
				(click)="onIdentityMenu(menu, defaultUnblocks || [])"
			/>
		}
	}
</ng-template>
